import { getDomainOrigin, getHeaders } from 'utils/serverConfig';

export const fetchMmvData = async ({ vehicle_type }) => {
    const url = `${getDomainOrigin()}/auto-insurance/mpos/mmv/?vehicle_type=${vehicle_type}`;
    const authHeaders = Object.entries(getHeaders()).reduce<
        Record<string, string>
    >((headers, [name, value]) => {
        if (name !== 'Access-Control-Allow-Origin' && value) {
            headers[name] = value;
        }
        return headers;
    }, {});

    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            ...authHeaders,
            'Content-Type': 'application/json',
            'SOURCE-ID': 'Test',
            'DATASET-LABEL': 'new',
        },
    });

    if (!response.ok) {
        const error = new Error(
            `MMV request failed with status ${response.status}`
        ) as Error & { status: number };
        error.status = response.status;
        throw error;
    }

    const data = await response.json();
    return data;
};
